import { useState } from "react";
import { toast } from "sonner";
import { Share, PlusSquare, Smartphone } from "lucide-react";
import { useInstallPrompt } from "../hooks/useInstallPrompt";

// One button, three behaviours depending on platform: a real one-tap install on Android/Chrome,
// a Share -> Add to Home Screen walkthrough on iOS (Apple gives no programmatic install API),
// and a plain-language nudge everywhere else. See useInstallPrompt for why the branch exists.
export default function InstallAppButton() {
  const { installed, isIOS, canPromptNatively, promptInstall } = useInstallPrompt();
  const [showIosSteps, setShowIosSteps] = useState(false);

  if (installed) return null;

  const handleClick = async () => {
    if (canPromptNatively) {
      await promptInstall();
    } else if (isIOS) {
      setShowIosSteps((v) => !v);
    } else {
      toast.info("Open this page in Chrome or Safari on your phone to install Mnandi as an app.");
    }
  };

  return (
    <div data-testid="install-app-section">
      <button onClick={handleClick} data-testid="install-app-button"
        className="h-10 px-4 rounded-lg border border-sand bg-white hover:bg-sand/40 text-sm font-medium transition-colors duration-200 inline-flex items-center gap-2">
        <Smartphone size={16} /> Install app
      </button>

      {showIosSteps && (
        <div className="mt-3 max-w-sm text-sm text-ink/70 bg-cream border border-sand rounded-lg p-4 space-y-2" data-testid="install-app-ios-steps">
          <p className="flex items-center gap-2"><Share size={15} className="shrink-0 text-tea-text" /> Tap the Share button in Safari</p>
          <p className="flex items-center gap-2"><PlusSquare size={15} className="shrink-0 text-tea-text" /> Choose "Add to Home Screen"</p>
        </div>
      )}
    </div>
  );
}
